import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function AllanLouisPage() {
  return <AttorneyBioTemplate attorney={attorneys['allan-louis-esq']} />;
}
